import { useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "app/components/ui/Button/Button";
import { showFlexRatesModal as showFlexRatesModalAction } from "app/pages/Booking/Quotation/quotationActionCreators";
import { INSURANCE_STANDARD } from "app/constants";
import "./FlexAsideButton.scss";
import { useNavigate, useLocation } from "react-router-dom";
import classNames from "classnames";
import IconFlex from "app/pages/.shared/IconFlex";

export const FlexAsideButton = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const booking = useSelector(state => state.booking);
	const quotation = useSelector(state => state.quotation);
	const dispatch = useDispatch();
	const showFlexRatesModal = useCallback(
		isOpened => dispatch(showFlexRatesModalAction(isOpened)),
		[dispatch]
	);

	useEffect(() => {
		showFlexRatesModal(false);
	}, []);

	const isFlexIncludedVisible = booking.insuranceFlex && !quotation.isFlexRatesModalOpened;

	const isFlexModificationVisible =
		isFlexIncludedVisible && !location.pathname.includes("/booking/confirmation");

	let isFlex = false;
	if (booking.insuranceFlex && booking.insuranceFlex.code !== INSURANCE_STANDARD) {
		isFlex = true;
	}
	const labelFlexModification =
		isFlexIncludedVisible && isFlex
			? "flex.rate.modify.flex.label"
			: "flex.rate.modify.standard.label";

	const onFlexUpdateBtnClick = () => {
		if (!location.pathname.includes("/booking/quote")) {
			// TODO A corriger car il faut aussi gérer le cas sdp "/sdp/booking/quote"
			navigate(
				{
					pathname: "/booking/quote",
				},
				{
					replace: true,
					state: {
						showFlexModalOnLoad: true,
					},
				}
			);

			// permet d'attendre d'être sur la page de quote pour afficher la modal flex
			setTimeout(() => {
				showFlexRatesModal(isFlexIncludedVisible);
			}, 500);
		} else {
			showFlexRatesModal(isFlexIncludedVisible);
		}
	};

	const flexAsideLabel = classNames("flex-aside__label", {
		"flex-aside__label--disabled": !isFlex,
	});

	return isFlexIncludedVisible ? (
		<div className="flex-aside">
			<div className={flexAsideLabel}>
				<IconFlex />
				<FormattedMessage id={labelFlexModification} />
			</div>
			{isFlexModificationVisible && (
				<Button onClick={onFlexUpdateBtnClick} className="flex-aside__btn">
					<FormattedMessage id="flex.rate.modify.btn.label" />
				</Button>
			)}
		</div>
	) : null;
};

export default FlexAsideButton;
